import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import Table, { Column } from "../../Components/Tables/Table";
import { roleList } from "../../Data/testData";
import PageHeader from "../../Layout/PageHeader";
import { useState } from "react";
import ExportLayout from "../../Layout/ExportLayout";
import CommonModal from "../../Components/Modals/CommonModal";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";

export default function RoleOverview() {
  const pageName = "Roles";
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
    useState({
      importModal: false,
      exportModal: false,
    });
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const handleShow = () => setShow(!show);
  const [showconfModal, setShowconfModal] = useState(false);
  const handleconfClose = () => setShowconfModal(false);

  const columns: Column[] = [
    {
      name: "Role Name",
      selector: (row: { name: string }) => (
        <span className="cursor-pointer text-primary">
            {row.name}
        </span>
    ),
    },
    {
      name: "Permission",
      selector: (row: { permission: string }) => row.permission,
    },
    {
      name: "No. of users assigned",
      selector: (row: { noOfAssignedUser: string }) => row.noOfAssignedUser,
    },
    {
      name: "Status",
      selector: (row: { status: boolean }) => {
        return row.status === true ? (
          <span className="badge text-bg-light border border-2 px-3 border-info-subtle cursor-pointer">
            Active
          </span>
        ) : (
          <span className="badge text-bg-light border border-2 px-3 border-danger-subtle cursor-pointer">
            Inactive
          </span>
        );
      },
    },
    {
      name: <PlusCircle />,
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={handelDeleteAction}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];
  const handelEditAction = (data: any) => {};
  const handelInactiveAction = (data: any) => {};
  const handelDeleteAction = (data: any) => {
    setShowconfModal(true);
  };
    const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleconfClose();
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  return (
    <>
      <PageHeader
        addUrl="/account/roles/add"
        listUrl="/account/roles/view_list"
        gridUrl=""
        name="Role"
        isShowUpload={false}
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />
      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="customerTableMainDiv">
        <Table columns={columns} data={roleList}  
        CheckboxStatus={false}
        pagination={{
          recordsPerPage: 15,
          totalRecords: roleList.length,
          onCurrentPageChange: onCurrentPageChange
        }} />
      
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      </div>
      <CommonConfirmationModal
      customClassName="header-border"
        show={showconfModal}
        content={<> You are about to delete this  <br />
        Are you Sure? </>}
        onModalSubmit={onModalSubmit}
      />

    </>
  );
}
